import { INITIAL_SAVE_REQUEST_META } from '../utils';
import { MutedTagsWidgetData } from './types';

const defaultMutedTagsWidgetData: NonNullable<MutedTagsWidgetData['initialData']> = {
  blacklistedTags: [],
};

export const defaultMutedTagsWidgetState: MutedTagsWidgetData = {
  initialData: defaultMutedTagsWidgetData,
  currentData: defaultMutedTagsWidgetData,
  isDirty: false,
  saveRequest: INITIAL_SAVE_REQUEST_META,
};
